import { put } from "redux-saga/effects";
import { Action } from "redux";

/**
 * Dispatches driver return values that may be a single Redux action or an action list.
 */
export function* putActionResult<T extends Action>(chainedAction: T[] | T) {
  if (!chainedAction) {
    return;
  }

  if (Array.isArray(chainedAction)) {
    for (const actionToDispatch of chainedAction) {
      if (actionToDispatch) {
        yield put(actionToDispatch);
      }
    }
    return;
  }

  yield put(chainedAction);
}
